module.exports = __webpack_public_path__ + "2d452318f9785c5c69abd37147a84d47.png";